<template>
  <div class="p-notification">
    <v-container class="header-cont the-main-concept">
      <h1 class="tab-header"> {{$t('profile.notifications')}}</h1>
    </v-container>
    <v-container class="the-main-concept">
      <v-layout justify-center>
        <v-flex sm10 xs12>
          <v-list three-line class="notification-comp">
            <template v-for="(item, index) in notifications">
              <v-list-tile class="note-list-product-req"
                           v-if="item.Product && (item.name === 'Product_Approved_By_Admin' || item.name === 'Product_Rejected_By_Admin')"
                           :key="item.id"
                           avatar
              >
                <v-layout row  justify-center class="notification-sect">
                  <v-flex lg4 sm6 d-flex align-center class="custom1">
                    <v-list-tile-avatar class="avatars-container" size="45">
                      <img src="../../assets/images/symbol.png" :alt="$t('avatar')">
                    </v-list-tile-avatar>
                    <v-list-tile-avatar size="24" class="g-filter">
                      <img v-if="item.name === 'Product_Approved_By_Admin'"
                           src="../../assets/images/accept.svg"
                           alt="Accept icon">
                      <img v-else
                           src="../../assets/images/reject.svg"
                           alt="Reject icon">
                    </v-list-tile-avatar>
                    <div class="user-content">
                      <v-list-tile-title v-html="$t('profile.giver_admin')"
                                         class="user-info"/>
                      <v-list-tile-sub-title class="note-req"
                                             v-html="item.Notification.NotificationTranslations[0].description"/>
                      <div v-if="item.Product.options && item.Product.options.note">
                        <v-list-tile-sub-title v-if="item.id !== notId"
                                               class="note-req"
                                               style="text-align: justify"
                                               v-html="item.Product.options.note.substring(0, 15)"/>
                        <v-list-tile-sub-title v-if="item.id === notId"
                                               class="note-req"
                                               style="text-align: justify"
                                               v-html="item.Product.options.note"/>
                        <a v-if="item.Product.options.note.length > 15" @click="activateReadMore(item.id)">
                          {{item.id === notId ? $t('profile.read_less') : $t('profile.read_more')}}
                        </a>
                      </div>
                    </div>
                    <img class="req-arrow"
                         v-if="item.name === 'Product_Approved_By_Admin'"
                         src="../../assets/images/arrow-accepted.svg"
                         alt="Accept icon">
                    <img class="req-arrow"
                         v-else
                         src="../../assets/images/arrow-rejected.svg"
                         alt="Reject icon">
                  </v-flex>
                  <v-flex lg4 sm6  class="custom2">
                    <div>
                      <router-link v-if="item.Product"
                                   :to="/products/ + item.Product.id + '/' + item.Product.displayDetails.name.replace(/\s+/g, '-')">
                        <v-list-tile-sub-title class="note-content"
                        >
                          <img class="note-image"
                               v-if="item.Product && item.Product.image"
                               :src="apiUrl + item.Product.image"
                               height="50"
                               :alt="item.Product.displayDetails.name">
                          <p class="note-message" v-if="item.Product.displayDetails.name">
                            {{item.Product.displayDetails.name}}</p>
                        </v-list-tile-sub-title>
                      </router-link>
                    </div>
                  </v-flex>
                  <v-flex class="custom3" lg4 sm12>
                    <v-list-tile-action>
                      <v-list-tile-action-text>{{ createTimeOrDate(item.createdAt) }}
                      </v-list-tile-action-text>
                      <v-spacer></v-spacer>
                    </v-list-tile-action>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile class="note-list-friend-req"
                           v-if="item.name === 'Friend_invitation' || item.name === 'Add_friend' || item.name === 'Invitation_declined'"
                           :key="item.id"
                           avatar
              >
                <v-layout row align-center justify-center class="notification-sect">
                  <v-flex lg6 sm12 xs12 d-flex align-center class="custom1">
                    <router-link :to="/accounts/ + item.Inviter.id">
                    <v-list-tile-avatar class="avatars-container" size="45">
                      <img v-if="item.Inviter && item.Inviter.image"
                           :src="apiUrl + item.Inviter.image"
                           :alt="$t('avatar')">
                      <img v-else src="../../assets/images/NoImage.png" :alt="$t('avatar')">
                    </v-list-tile-avatar>
                    </router-link>
                    <v-list-tile-avatar size="24" class="g-filter">
                      <img src="../../assets/images/friend-icon.svg" alt="Friend icon">
                    </v-list-tile-avatar>
                    <div class="user-content">
                      <router-link :to="`/accounts/${item.Inviter.id}`"
                                   v-html="item.Inviter.firstName + ' ' +  (item.Inviter.lastName || '')"
                                   class="user-info"/>
                      <v-list-tile-sub-title v-html="item.Notification.NotificationTranslations[0].description"
                                             class="note-req"/>
                    </div>
                  </v-flex>

                  <v-flex lg6 sm12 xs12 d-flex class="custom3">
                    <div class="buttons">
                      <v-list-tile-action>
                        <v-btn v-if="item.notificationType === 1"
                               class="decline-btn"
                               @click="acceptInvitation(item, false)"
                               :disabled="isDisabled"
                        >{{$t('profile.decline')}}
                          <img src="../../assets/images/reject.svg" alt="reject">
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn v-if="item.notificationType === 1"
                               class="accept-btn" flat
                               :ripple="false"
                               @click="acceptInvitation(item, true)"
                               :disabled="isDisabled"
                        >
                          {{$t('profile.accept')}}
                          <img src="../../assets/images/confirm.svg" alt="confirm">
                        </v-btn>
                      </v-list-tile-action>
                    </div>
                    <div class="request-message-content" v-if="item.notificationType === 3">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/accept.svg" alt="accept">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestAccepted')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <div class="request-message-content" v-if="item.notificationType === 4">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/combined-shape.svg" alt="decline">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestRejected')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <v-list-tile-action>
                      <v-list-tile-action-text class="data-time">{{ createTimeOrDate(item.createdAt) }}
                      </v-list-tile-action-text>
                      <v-spacer></v-spacer>
                    </v-list-tile-action>
                    <v-list-tile-action v-if="false">
                      <v-btn icon class="mx-0" @click="deleteNotification(item.id)">
                        <v-icon color="pink">clear</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile class="note-list-product-req"
                           v-if="item.name === 'Product_request' || item.name === 'Request_accepted' || item.name === 'Request_declined'"
                           :key="item.id"
                           avatar
              >
                <v-layout row  justify-center class="notification-sect">
                  <v-flex lg4 sm6 d-flex align-center class="custom1">
                    <router-link :to="/accounts/ + item.Inviter.id">
                    <v-list-tile-avatar class="avatars-container" size="45">
                      <img v-if="item.Inviter && item.Inviter.image"
                           :src="apiUrl + item.Inviter.image"
                           :alt="$t('avatar')">
                      <img v-else src="../../assets/images/NoImage.png" :alt="$t('avatar')">
                    </v-list-tile-avatar>
                    </router-link>
                    <v-list-tile-avatar size="24" class="g-filter">
                      <img src="../../assets/images/request.svg" alt="request">
                    </v-list-tile-avatar>
                    <div class="user-content">
                      <router-link :to="`/accounts/${item.Inviter.id}`"
                                   v-html="item.Inviter.firstName + ' ' +  (item.Inviter.lastName || '') + ' ' +
                                    '<br>' + item.Inviter.email + '<br>' + item.Inviter.phoneNumber"
                                   class="user-info"/><br>
                      <router-link class="user-info" v-if="item.Inviter.city && item.Inviter.country" :to="`/accounts/${item.Inviter.id}`"
                                                         v-html="item.Inviter.city + ', ' + item.Inviter.country"/>
                      {{item.Inviter.city}}
                      <v-list-tile-sub-title class="note-req"
                                             v-html="item.Notification.NotificationTranslations[0].description"/>
                    </div>
                    <img class="req-arrow"
                         v-if="item.ProductRequest && item.ProductRequest.accepted === null"
                         src="../../assets/images/arrow-pending.svg"
                         alt="pending">
                    <img class="req-arrow"
                         v-if="item.ProductRequest && item.ProductRequest.accepted === true"
                         src="../../assets/images/arrow-accepted.svg"
                         alt="accepted">
                    <img class="req-arrow"
                         v-if="item.ProductRequest && item.ProductRequest.accepted === false"
                         src="../../assets/images/arrow-rejected.svg"
                         alt="rejected">
                  </v-flex>
                  <v-flex lg4 sm6  class="custom2">
                    <div>
                      <router-link v-if="item.ProductRequest && item.ProductRequest.Product"
                                   :to="/products/ + item.ProductRequest.Product.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                      <v-list-tile-sub-title class="note-content"
                      >
                        <img class="note-image"
                             :alt="item.displayDetails.name"
                             v-if="item.ProductRequest && item.ProductRequest.Product.image"
                             :src="apiUrl + item.ProductRequest.Product.image" height="50">
                        <p class="note-message" v-if="item.ProductRequest">
                          {{item.ProductRequest.message}}</p>
                      </v-list-tile-sub-title>
                      </router-link>
                    </div>
                  </v-flex>
                  <v-flex class="custom3" lg4 sm12>

                    <div class="buttons">
                      <v-list-tile-action
                              v-if="item.ProductRequest && item.ProductRequest.accepted === null">
                        <v-btn class="decline-btn" :ripple="false" @click="rejectRequest(item.ProductRequest.id, false)" :disabled="isDisabled">
                          {{$t('products.decline')}}
                          <img src="../../assets/images/reject.svg" alt="reject">
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action
                              v-if="item.ProductRequest && item.ProductRequest.accepted === null">
                        <v-btn class="accept-btn" :ripple="false" @click="confirmRequest(item.ProductRequest.id)">
                          {{$t('products.accept')}}
                          <img src="../../assets/images/confirm.svg" alt="confirm">
                        </v-btn>
                      </v-list-tile-action>
                    </div>
                    <div class="request-message-content"
                         v-if="item.ProductRequest && item.ProductRequest.accepted === true">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/accept.svg" alt="accept">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestAccepted')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <div class="request-message-content"
                         v-if="item.ProductRequest && item.ProductRequest.accepted === false">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/combined-shape.svg" alt="reject">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestRejected')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <v-list-tile-action>
                      <v-list-tile-action-text>{{ createTimeOrDate(item.createdAt) }}
                      </v-list-tile-action-text>
                      <v-spacer></v-spacer>
                    </v-list-tile-action>
                    <v-list-tile-action v-if="false">
                      <v-btn icon class="mx-0" @click="deleteNotification(item.id)">
                        <v-icon color="pink">clear</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-flex>
                </v-layout>
                <v-layout align-center justify-space-between class="contact-by-message" v-if="item.ProductRequest && item.ProductRequest.accepted === true">
                  <v-list-tile-title class="contact-by-message-info">
                    <span v-if="stateUserData.id === item.fromUserId" class="message-info-xs">{{item.displayDetails.contactBy}}</span>
                  </v-list-tile-title>
                </v-layout>
              </v-list-tile>
              <v-list-tile class="note-list-group-req"
                           v-if="item.name === 'Group_invitation_declined' || item.name === 'Group_invitation_accepted' || item.name === 'Group_invitation'"
                           :key="item.id"
                           avatar
              >
                <v-layout row justify-center class="notification-sect">
                  <v-flex lg4 sm6 align-center d-flex class="custom1">
                    <router-link :to="/accounts/ + item.Inviter.id">
                    <v-list-tile-avatar class="avatars-container" size="45">
                      <img v-if="item.Inviter && item.Inviter.image"
                           :src="apiUrl + item.Inviter.image"
                           :alt="$t('avatar')">
                      <img v-else src="../../assets/images/NoImage.png" :alt="$t('avatar')">
                    </v-list-tile-avatar>
                    </router-link>
                    <v-list-tile-avatar size="24" class="g-filter">
                      <img src="../../assets/images/group-request.svg" alt="">
                    </v-list-tile-avatar>
                    <div class="user-content">
                      <router-link :to="`/accounts/${item.Inviter.id}`"
                                   v-html="item.Inviter.firstName + ' ' +  (item.Inviter.lastName || '')"
                                   class="user-info"/>
                      <v-list-tile-sub-title class="note-req"
                                             v-html="item.Notification.NotificationTranslations[0].description"/>
                    </div>
                    <img class="req-arrow"
                         v-if="item.GroupRequest && item.GroupRequest.accepted === null"
                         src="../../assets/images/arrow-pending.svg"
                         :alt="item.displayDetails.name">
                    <img class="req-arrow"
                         v-if="item.GroupRequest && item.GroupRequest.accepted === true"
                         src="../../assets/images/arrow-accepted.svg"
                         :alt="item.displayDetails.name">
                    <img class="req-arrow"
                         v-if="item.GroupRequest && item.GroupRequest.accepted === false"
                         src="../../assets/images/arrow-rejected.svg"
                         :alt="item.displayDetails.name">
                  </v-flex>
                  <v-flex lg4 sm6 align-center class="custom2">
                    <div>
                      <v-list-tile-sub-title class="note-content"
                                             v-if="item.GroupRequest && item.GroupRequest.Group">
                        <router-link v-if="item.GroupRequest && item.GroupRequest.Group.image" :to="'/profile/my-groups/' + item.GroupRequest.Group.id">
                        <img class="note-image"
                             :src="apiUrl + item.GroupRequest.Group.image"
                             :alt="item.displayDetails.name">
                        </router-link>
                        <div class="d-flax">
                          <router-link v-if="item.GroupRequest && item.GroupRequest.Group.image" :to="'/profile/my-groups/' + item.GroupRequest.Group.id">
                            <p class="group-name">{{item.displayDetails.name}}</p>
                          </router-link>
                          <p class="note-message" v-if="item.GroupRequest">
                            {{item.GroupRequest.message}}</p>
                          <div class="d-flex flex-row">
                            <div class="justify-end w-15" v-if="item.displayDetails.description">
                              <v-menu open-on-hover bottom offset-y>
                                <v-flex slot="activator"
                                        class="d-flex justify-center align-center">
                                  <img class="info-image"
                                       src="../../assets/images/information.svg"
                                       alt="Info image"/>
                                </v-flex>
                                <div class="description-group">
                                  {{item.displayDetails.description}}
                                </div>
                              </v-menu>
                            </div>
                            <p class="member-count" v-if="item.GroupRequest">
                              {{item.GroupRequest.Group.UserGroups.length + " " +
                              (item.GroupRequest.Group.UserGroups.length > 1 ?
                              $t('group.members') : $t('group.member'))}}</p>
                          </div>
                        </div>
                      </v-list-tile-sub-title>
                    </div>
                  </v-flex>
                  <v-flex class="custom3"  lg4 sm12>
                    <div class="buttons">
                      <v-list-tile-action
                              v-if="item.GroupRequest && item.GroupRequest.accepted === null">
                        <v-btn class="decline-btn" :ripple="false" @click="acceptGroupRequest(item, false)" :disabled="isDisabled">
                          {{$t('group.decline')}}
                          <img src="../../assets/images/reject.svg" alt="reject">
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action
                              v-if="item.GroupRequest && item.GroupRequest.accepted === null">
                        <v-btn class="accept-btn" :ripple="false" @click="acceptGroupRequest(item, true)" :disabled="isDisabled">
                          {{$t('group.accept')}}
                          <img src="../../assets/images/confirm.svg" alt="confirm">
                        </v-btn>
                      </v-list-tile-action>
                    </div>
                    <div class="request-message-content"
                         v-if="item.GroupRequest && item.GroupRequest.accepted === true">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/accept.svg" alt="accept">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestAccepted')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <div class="request-message-content"
                         v-if="item.GroupRequest && item.GroupRequest.accepted === false">
                      <v-layout align-center justify-space-between class="request-message">
                        <img src="../../assets/images/combined-shape.svg" alt="">
                        <v-list-tile-title class="request-message-info">
                          {{$t('products.requestRejected')}}
                        </v-list-tile-title>
                      </v-layout>
                    </div>
                    <v-list-tile-action>
                      <v-list-tile-action-text>{{ createTimeOrDate(item.createdAt) }}
                      </v-list-tile-action-text>
                      <v-spacer></v-spacer>
                    </v-list-tile-action>
                    <v-list-tile-action v-if="false">
                      <v-btn icon class="mx-0" @click="deleteNotification(item.id)">
                        <v-icon color="pink">clear</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-divider v-if="index +1 < notifications.length" :key="`divider-${index}`"/>
            </template>
            <template v-if="notifications.length === 0">
              <v-alert :value="true" color="grey" icon="warning" align="center" class="warning-icon">
                {{$t('profile.notifications')}}
              </v-alert>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" max-width="550px">
        <v-form ref="form" v-model="valid" lazy-validation class="disable-form-contact">
          <v-card class="contact-with-user-modal">
            <v-card-title class="modal-close-btn-sect">
              <v-btn
                      class="cancel-user-contact-modal-btn"
                      :ripple="false"
                      flat
                      @click.native="close">
                <v-icon>icon-cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-md-center headline-title title-name">
              <span>{{$t('profile.contact_me')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap class="chose-contact-type-sect">
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox v-model="enabledTel"
                                  :label="$t('profile.contact_by_phone')"
                                  color="#8890e4"
                                  class="shrink mr-2"/>
                      <v-text-field
                              :disabled="!enabledTel"
                              v-model="contactByTel"
                              :rules="contactByTelRules"
                              color="indigo"
                              class="shrink mr-2 type-input"
                              flat-rigth
                              solo
                              placeholder="+374XXXXXXXX"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox v-model="enabledEmail"
                                  :label="$t('profile.contact_by_email')"
                                  color="#8890e4"
                                  class="shrink mr-2"/>
                      <v-text-field
                              :disabled="!enabledEmail"
                              v-model="contactByEmail"
                              :rules="contactByEmailRules"
                              color="indigo"
                              class="shrink mr-2 type-input"
                              flat-rigth
                              solo
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions class="modal-btn-sect">
              <v-btn class="cancel-request-btn2" :ripple="false" @click.native="close">{{$t('products.cancel')}}</v-btn>
              <div :class="!enabledTel && !enabledEmail && 'disabled-sect'" :title="!enabledTel && !enabledEmail && 'Select any contact way'" class="unable-sect"><v-btn class="send-request-btn" :disabled="!enabledTel && !enabledEmail" :ripple="false" @click.native="save">{{$t('products.send')}}</v-btn></div>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {EventBus} from '../../event-bus'
import {changeImageSize, validateEmail} from '../../helpers/main'

export default {
  name: 'Notifications',
  data: () => ({
    notifications: {},
    notId: null,
    apiUrl: process.env.ROOT_API,
    dialog: false,
    productId: null,
    enabledTel: false,
    contactByTel: '',
    enabledEmail: true,
    contactByEmail: '',
    valid: true,
    isDisabled: false,
    disabledTimeout: 500
  }),
  computed: {
    ...mapState({
      stateUserData: state => state.auth.userData,
      notification: state => state.profile.notifications,
      newNotificationsCount: state => state.profile.newNotificationsCount
    }),
    contactByTelRules () {
      const rules = []
      if (this.enabledTel) {
        rules.push(v => !!v || this.$t('profile.phone_required'))
        rules.push(v => (!!v && /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('profile.phone_not_valid'))
      }
      return rules
    },
    contactByEmailRules () {
      const rules = []
      if (this.enabledEmail) {
        rules.push(v => !!v || this.$t('email_required'))
        rules.push(v => validateEmail(v) || this.$t('email_not_valid'))
      }
      return rules
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    newNotification: function (data) {
      // const {userId, type, message} = data
      this.getNotifications()
    }
  },
  methods: {
    initialize () {
    },
    acceptInvitation (notification, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      let data = {}
      data.id = notification.id
      data.userId = notification.userId
      data.fromUserId = notification.fromUserId
      data.accept = accept
      this.$store.dispatch('profile/acceptInvitation', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$t(response.type))
        this.getNotifications()
      }).catch(console.error)
    },
    rejectRequest (id, accept) {
      this.acceptRequest(id, accept)
    },
    confirmRequest (id) {
      if (this.stateUserData) {
        this.contactByTel = this.stateUserData.phoneNumber
        this.contactByEmail = this.stateUserData.email
      }
      this.productId = id
      this.dialog = true
    },
    acceptRequest (id, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      let data = {}
      data.id = id
      data.accept = accept
      if (this.enabledTel && this.contactByTel) {
        data.contactByTel = this.contactByTel
      }
      if (this.enabledEmail && this.contactByEmail) {
        data.contactByEmail = this.contactByEmail
      }
      this.$store.dispatch('products/acceptRequest', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$t(response.type))
        this.getNotifications()
      }).catch(console.error)
    },
    acceptGroupRequest (item, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true

      let data = {}
      data.id = item.GroupRequest.id
      data.accept = accept
      this.$store.dispatch('groups/acceptGroupRequest', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$t(response.type))
        this.getNotifications()
      }).catch(console.error)
    },
    deleteNotification (item) {
      this.$store.dispatch('profile/deleteNotification', item).then((res) => {
        this.$toastr(res.type, res.message, this.$t(res.type))
        this.getNotifications()
      }).catch(console.error)
    },
    languageChanged () {
      this.getNotifications()
    },
    getNotifications () {
      this.$store.dispatch('profile/getUserNotifications').then((res) => {
        let _notifications = []
        res.notificationsFromUserId.forEach(notification => {
          if (notification.ProductRequest && notification.ProductRequest.accepted !== null) {
            _notifications.push(notification)
          }
          if (notification.GroupRequest && notification.GroupRequest.accepted !== null) {
            _notifications.push(notification)
          }
          if (notification.name === 'Invitation_declined') {
            _notifications.push(notification)
          }
        })
        res.notifications.forEach(notification => {
          if (notification.notificationType === 1 || notification.notificationType === 3 || notification.notificationType === 4 || notification.notificationType === 5 || notification.notificationType === 11 || notification.notificationType === 12) {
            _notifications.push(notification)
          } else {
            if (notification.ProductRequest) {
              _notifications.push(notification)
            } else if (notification.GroupRequest) {
              _notifications.push(notification)
            }
          }
        })
        _notifications.sort(function (a, b) {
          return b.id - a.id
        })
        let notifications = []
        let notificationsData = JSON.parse(JSON.stringify(_notifications))
        notificationsData.forEach(not => {
          if (not.GroupRequest) {
            not.displayDetails = {}
            if (not.GroupRequest.Group && not.GroupRequest.Group.GroupTranslations) {
              not.GroupRequest.Group.GroupTranslations.forEach(groupTranslation => {
                if (groupTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
                  not.displayDetails.name = groupTranslation.name
                  not.displayDetails.description = groupTranslation.description && groupTranslation.description.length > 50 ? groupTranslation.description = groupTranslation.description.substring(0, 50) + '...' : groupTranslation.description
                } else if (!not.displayDetails.name) {
                  not.displayDetails.name = groupTranslation.name
                  not.displayDetails.description = groupTranslation.description && groupTranslation.description.length > 50 ? groupTranslation.description = groupTranslation.description.substring(0, 50) + '...' : groupTranslation.description
                }
              })
            }
          }
          if (not.Product) {
            not.Product.displayDetails = {}
            not.Product.image = changeImageSize(not.Product.image, 'md')
            not.Product.ProductTranslations.forEach(productTranslation => {
              if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
                not.Product.displayDetails.name = productTranslation.name
              } else if (!not.Product.displayDetails.name) {
                not.Product.displayDetails.name = productTranslation.name
              }
            })
          }
          if (not.ProductRequest) {
            not.displayDetails = {}
            var contactBy = ''
            if (not.ProductRequest.options) {
              contactBy = this.$root.$t('profile.contact_by')
              if (not.ProductRequest.options.byTel && not.ProductRequest.options.byEmail) {
                contactBy = contactBy + this.$root.$t('profile.phone') + not.ProductRequest.options.byTel + this.$root.$t('profile.or') + this.$root.$t('profile.email') + not.ProductRequest.options.byEmail
              } else {
                contactBy = contactBy + (not.ProductRequest.options.byTel ? (this.$root.$t('profile.phone') + not.ProductRequest.options.byTel) : (this.$root.$t('profile.email') + not.ProductRequest.options.byEmail))
              }
              not.displayDetails.contactBy = contactBy
            }
            if (not.ProductRequest.Product && not.ProductRequest.Product.ProductTranslations) {
              not.ProductRequest.Product.ProductTranslations.forEach(productTranslation => {
                if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
                  not.displayDetails.name = productTranslation.name
                  not.displayDetails.description = productTranslation.description && productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
                } else if (!not.displayDetails.name) {
                  not.displayDetails.name = productTranslation.name
                  not.displayDetails.description = productTranslation.description && productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
                }
              })
            }
          }
          notifications.push(not)
        })
        this.notifications = notifications
      }).catch(console.error)
    },
    createTimeOrDate (createdAt) {
      (localStorage.getItem('lang') && localStorage.getItem('lang') === 'hy') ? this.$moment.locale('hy-am') : this.$moment.locale('en')
      let now = this.$moment()
      let createDate = this.$moment(createdAt)
      let time = ''
      if (now.diff(createDate, 'hours') < 1) {
        time = this.$moment(createDate).startOf('minutes').fromNow()
      } else if (now.diff(createDate, 'days') < 1) {
        time = createDate.format('LT')
      } else if (now.diff(createDate, 'days') < 2) {
        time = this.$moment().subtract(1, 'days').calendar()
      } else {
        time = createDate.format('MMMM DD')
      }
      return time.charAt(0).toUpperCase() + time.slice(1)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.productId = null
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        this.acceptRequest(this.productId, true)
        this.close()
      }
    },
    activateReadMore (notId) {
      if (this.notId !== notId) {
        this.notId = notId
      } else {
        this.notId = null
      }
    }
  },
  watch: {
    newNotificationsCount: function (val) {
      if (val) {
        this.$store.dispatch('profile/hideNotificationCount').then((res) => {
        }).catch(console.error)
      }
    },
    dialog (val) {
      val || this.close()
      this.$refs.form.resetValidation()
    }
  },
  created () {
    EventBus.$on('language-changed', this.languageChanged)
    this.initialize()
  },
  beforeMount () {
    this.getNotifications()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/notificationPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/Notifications.vue